import { Howl, Howler } from 'howler';

const sounds = {
  bgsound: new Howl({ src: ['/assets/scratch-audio/soundtrack.mp3'], loop: true, volume: 0.25 }),
  reveal: new Howl({ src: ['/assets/scratch-audio/reveal_sound.mp3'] }),
  tryagain: new Howl({ src: ['/assets/scratch-audio/tryagain_sound.mp3'] }),
  win: new Howl({ src: ['/assets/scratch-audio/win.mp3'] }),
  bigwin: new Howl({ src: ['/assets/scratch-audio/bigwin_sound.mp3'] }),
};

// Play functions
export function playBgSound() {
    if (!sounds.bgsound.playing()) {
      sounds.bgsound.play();
    }
}

export function pauseBgSound() {
  if (sounds.bgsound.playing()) {
    sounds.bgsound.pause();
  }
}

export function playReveal() {
  sounds.reveal.play();
}

export function playWin() {
  sounds.win.play();
}
export function playtryagain() {
    sounds.tryagain.play();
  }

export function playBigWin() {
  sounds.bigwin.play();
}
export function stopBgSound() {
  sounds.bgsound.stop();
}

export function isBgSoundPlaying() {
  return sounds.bgsound.playing();
}

// Mute/unmute all sounds
export const soundManager = {
  mute() {
    Howler.mute(true);
  },
  unmute() {
    Howler.mute(false);
  },
  isMuted() {
    return Howler._muted;
  },
  playBgSound,
  pauseBgSound, 
  stopBgSound,
  isBgSoundPlaying,
  playReveal,
  playWin,
  playtryagain,
  playBigWin,
  
};

document.addEventListener('visibilitychange', () => {
  if (document.hidden) {
    // Pause background sound when tab is hidden
    soundManager.pauseBgSound();
  } else {
    // Resume background sound when tab is visible again
    soundManager.playBgSound();
  }
});

export const bgsound = sounds.bgsound; 